import {
  ILoggedPackagesStoreType,
  ILoggedPackageStoreType,
} from "./loggedPackages.reducer";

export function appendOrUpdateLoggedPackage(
  loggedPackages: ILoggedPackagesStoreType,
  packageToUpdate: ILoggedPackageStoreType,
): ILoggedPackagesStoreType {
  return [...loggedPackages, packageToUpdate];
}
